import Logger from '../logging/logger';

export type NewContentLoadedEvent = {
    container: HTMLElement | Document;
}

async function onNewContentLoaded( event: CustomEvent<NewContentLoadedEvent> ) {
    const detail = event.detail || {};
    const container = detail.container || document;

    Logger.info( 'Event Triggered: onNewContentLoaded', detail );

    // Set Saved Status for newly loaded content
    window.dispatchEvent( new CustomEvent( 'twc:update-saved-status', {
        bubbles: true,
        detail: {
            container: container,
        },
    } ) );
}

export default onNewContentLoaded;
